import SensorsIcon from '@mui/icons-material/Sensors';

const ClusterIcon = ({ color, total }) => {
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <SensorsIcon style={{ color: color, fontSize: 30 , filter: 'blur(2px)' }}/>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1 }}>
        <svg width="75" height="75" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="4" stroke="none" strokeWidth="2" fill={color} />
          <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="4" fill="black">
            {total}
          </text>
        </svg>
      </div>
    </div>
  );
};

export default ClusterIcon;